import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { UrlEnum } from "src/app/enums/urls.enum";
import { BlogPost } from "src/app/models/blogPost";

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.css"],
})
export class BlogComponent implements OnInit {
  BLOG: string = "/blog/";
  blogPosts: BlogPost[];
  constructor(private titleService: Title) {
    this.blogPosts = [];
  }

  ngOnInit() {
    this.titleService.setTitle("Lejdi Prifti - Blog");
    this.fillBlogPosts();
  }

  fillBlogPosts(): void {
    this.blogPosts = [
      {
        title: "Implementation of the Abstract Factory pattern (with Kotlin)",
        link: this.BLOG + UrlEnum.AbstractFactoryPattern,
      },
      {
        title: "Implementation of the Builder pattern (with Typescript)",
        link: this.BLOG + UrlEnum.BuilderPattern,
      },
      {
        title: "Implementation of the Visitor pattern (with Java)",
        link: this.BLOG + UrlEnum.VisitorPattern,
      },
    ];
  }

  search(event: any) {
    this.fillBlogPosts();
    this.blogPosts = this.blogPosts.filter((el) => {
      return el.title.toLowerCase().includes(event.target.value.toLowerCase());
    });
  }
}
